export default "5a4b76ccf877c415.svg"